export { default as LaftLogo } from './integrationTypes/LAFT.png';
export { default as FdvWebLogo } from './integrationTypes/FDVWeb.png';
export { default as FdvHusetLogo } from './integrationTypes/FDVHuset.png';
export { default as SlackLogo } from './integrationTypes/Slack.png';
export { default as ProperlyLogo } from './integrationTypes/PropelyLogo.png';
